import React, { FC } from 'react';
import { TWCPage } from '@components';

import { mapPageTestIDs } from '@constants';
import { Route } from '@types';

import { MapPageContent } from './MapPageContent/MapPageContent';

type MapPageProps = {
  route: Route;
};

export const MapPage: FC<MapPageProps> = ({ route }) => {
  const { useDefaultLocation } = route.params ?? {};

  return (
    <TWCPage
      childIds={[mapPageTestIDs.changeMapButton, mapPageTestIDs.alertTilesList, mapPageTestIDs.mapLegendSection]}
      firstFocus={mapPageTestIDs.changeMapButton}
      isMenuItem={false}
      pageID={mapPageTestIDs.mapPage}
    >
      <MapPageContent useDefaultLocation={useDefaultLocation} />
    </TWCPage>
  );
};
